import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductNotInsuranceListComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    products: flights.ProductModel[];

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    onProductDetails(product: flights.ProductModel) {
        this.$emit('product-details', product);

        // (<any>this).$ga.sendEvent('product',
        //     'detail',
        //     `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
        //     this.gaParams
        // );
    }

    onProductSelectionChange(product: flights.ProductModel, value: boolean) {
        if (value) {
            product.choiceType = api.ProductChoiceType.manualAccepted;
        }
        this.$emit('product-selection-change', product, value);
    }

    onFlightTerms() {
        if (this.reservation.selectedFlight) {
            this.$emit('flight-terms', this.reservation.selectedFlight.uniqueId);
        }
    }
}
